import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonService from "../common/commonService";
import { API_URLS, STATUS_CODES } from "../common/constants";
import { toast } from "react-toastify";
import { startLoading, stopLoading } from "./commonSlice";

const initialState = {
  errorMessage: "",
  error: null,
  isEmployeesAdded: false,
  fileData: null,
};

export const addMultipleEmployees = createAsyncThunk(
  "multiple/employees",
  async (
    {
      data,
      validateOnly = false,
      partial = false,
      approveIdentityUpdates = false,
      identityUpdateDigest = "",
      payrollWriteDigest = "",
      approveEmployerTransfers = false,
      employerTransferDigest = "",
      employerTransferRows = [],
    },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(startLoading());
    const query = new URLSearchParams();
    if (validateOnly) query.set("validateOnly", "true");
    if (partial) query.set("partial", "true");
    if (approveIdentityUpdates) query.set("approveIdentityUpdates", "true");
    if (identityUpdateDigest) {
      query.set("identityUpdateDigest", identityUpdateDigest);
    }
    if (payrollWriteDigest) {
      query.set("payrollWriteDigest", payrollWriteDigest);
    }
    if (approveEmployerTransfers) {
      query.set("approveEmployerTransfers", "true");
    }
    if (employerTransferDigest) {
      query.set("employerTransferDigest", employerTransferDigest);
    }
    if (employerTransferRows.length > 0) {
      query.set("employerTransferRows", employerTransferRows.join(","));
    }
    const url = `${API_URLS.IMPORT_CSV}${query.toString() ? `?${query}` : ""}`;
    const res = await commonService.postRequestForFormData(url, data);
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      let msg = res.message;
      if (typeof res.data === "string" && res.data) {
        msg += " (" + String(res.data) + ")";
      }
      toast.error(msg);
      return rejectWithValue(msg);
    }
    if (!validateOnly) toast.success(res.message);
    return res;
  },
);

const multiEmployeeSlice = createSlice({
  name: "data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addMultipleEmployees.pending, (state) => {
        return {
          ...state,
          error: null,
          isEmployeesAdded: false,
          fileData: null,
        };
      })
      .addCase(addMultipleEmployees.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          isEmployeesAdded: true,
          fileData: action.payload.data,
        };
      })
      .addCase(addMultipleEmployees.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          isEmployeesAdded: false,
          fileData: null,
        };
      });
  },
});

const { reducer } = multiEmployeeSlice;
export default reducer;
